<div class="banner">
    <div class="banner-right"></div>
    <div class="banner-center">
        <div class="banner-title">
            <h1>חיפוש עובד סוציאלי</h1>
        </div>
        <div class="banner-split"></div>
        <div class="banner-text">
            <ul>
                <li><b>לתשומת לבך, ניתן לחפש על פי מספר תעודת זהות, מספר רישום או על פי שם פרטי ושם משפחה.<br/>חיפוש על פי שם פרטי או שם משפחה בלבד לא ישלוף נתונים, גם במקרה שהוזן מספר זהות.</b></li>
                <li>בחיפוש על פי תעודת זהות, ניתן להדפיס את תוצאות החיפוש לצורך הצגת אישור.</li>
                <li class="legal-note">
                    <div><b>הערה משפטית:</b></div>
                    <div>
                        המידע המוצג באתר משמש לידיעה וכשרות לציבור בלבד.<br>
                        אין ברישום בפנקס העובדים הסוציאליים משום היתר עבודה בישראל.
                    </div>
                </li>
                <li class="liLinkExtra">הרשימה הקובעת היא זו המתפרסמת בפנקס העובדים הסוציאליים 
                    <a class="TextTitleLink" (click)="showLinkExtra()" href="javascript:void();">להרחבה</a>
                    <div class="linkExtra" [ngClass]="{'hide':showExtra==false,'show':showExtra==true}" [innerHTML]="extraLinkText"></div>
                </li>
                <li>לתשומת לבך, המערכת אינה מציגה מידע על בקשות לרישום, הנמצאות בתהליך אישור.</li>
            </ul>
        </div>
    </div>
    <div class="banner-left"></div>
</div>
<form #formElem [formGroup]="form" (ngSubmit)="onSubmit()" class="form-fields">
    <div class="box">
        <div class="banner-mobile"></div>
        <div class="field">
            <label for="TzNumber">מספר זהות:</label>
            <input type="number" formControlName="TzNumber" (input)="maxlength($event,9)"/>
        </div>
        <div class="msg">{{getErrors('TzNumber')}}</div>
        <div class="field">
            <label for="RegistrationNumber">מספר רישום בפנקס:</label>
            <input type="number" formControlName="RegistrationNumber" (input)="maxlength($event,9)"/>
        </div>
        <div class="msg">{{getErrors('RegistrationNumber')}}</div>
        <!--<div class="row">
            <div class="col-2">-->
                <div class="field">
                    <label for="FirstName">שם פרטי:</label>
                    <input formControlName="FirstName" maxlength="15"/>
                </div>
                <div class="msg">{{getErrors('FirstName')}}</div>
            <!--</div>
            <div class="col-2">-->
                <div class="field">
                    <label for="LastName">שם משפחה:</label>
                    <input formControlName="LastName" maxlength="15"/>
                </div>
                <div class="msg">{{getErrors('LastName')}}</div>
            <!--</div>
        </div>-->
        <div class="field">
            <div class="msg">{{getErrors('RecaptchaResponse')}}</div>
        </div>
    </div>

    <div class="buttons">
        <div class="btn-s">
            <button class="m-t-10" mat-raised-button type="submit"><mat-icon>search</mat-icon>חיפוש</button>
        </div>
        <div class="btn-c">
            <button class="m-t-10" mat-raised-button (click)="clean()"><mat-icon>clear_all</mat-icon>ניקוי</button>
        </div>
    </div>
    <re-captcha #captchaRef="reCaptcha" [siteKey]="siteKey" (resolved)="recaptchaResolve($event)" size="invisible"></re-captcha>

    <div *ngIf="loading" class="loading">
        <mat-spinner class="mat-spinner-color"></mat-spinner>
    </div>
            
    <div *ngIf="sw.ResultCode==1" class="results">
        <div class="results-title">
            <div>נמצאו {{sw.SocialWorkers.length}} תוצאות</div>
            <!--<div class="search-img"></div>-->
        </div>
        <div class="results-box">
        <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef> שם העובד הסוציאלי </th>
                <td mat-cell *matCellDef="let element" class="mobile-hide">
                    <div class="sw-name">
                        <span>{{element.Name}}</span>
                    </div>
                    <div *ngIf="element.SocialWorkerNote" class="note"><mat-icon color="warn">warning</mat-icon>&nbsp;{{element.SocialWorkerNote}}</div>
                </td>  
            </ng-container>
            <ng-container matColumnDef="RegistrationNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> מספר רישום </th>
                <td mat-cell *matCellDef="let element" class="mobile-cell">
                    <label class="mobile">מספר רישום </label>
                    <span>{{element.RegistrationNumber}}</span>
                    <mat-icon class="mobile" (click)="expandedElement = expandedElement === element ? null : element">{{expandedElement === element ?'expand_less':'expand_more'}}</mat-icon>
                </td>
            </ng-container>
            <ng-container matColumnDef="RegistrationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> תאריך רישום בפנקס </th>
                <td mat-cell *matCellDef="let element" class="mobile-hide"> {{getRegistrationDate(element)}} </td>
            </ng-container>
            <ng-container matColumnDef="Print">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element" class="mobile-hide"> <button mat-raised-button (click)="printClick(element)"><mat-icon>print</mat-icon> הדפסה</button> </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element">
                    <div class="example-element-detail"
                        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                        <div class="example-element-1"><label>שם העובד הסוציאלי</label> <span>{{element.Name}} </span></div>
                        <div class="example-element-2"><label>תאריך רישום בפנקס</label> <span>{{getRegistrationDate(element)}} </span></div>
                        <div class="example-element-3" *ngIf="element.SocialWorkerNote" class="note"><mat-icon color="warn">warning</mat-icon>&nbsp;{{element.SocialWorkerNote}}</div>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === row">
            </tr>
            <tr mat-row *matRowDef="let row2; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
        </div>
        <!--<div *ngIf="sw.SocialWorkers.length==1">
            <mat-card class="sw-card" *ngFor="let w of sw.SocialWorkers">
                <mat-card-header>
                    <mat-card-title><b>{{w.Name}}</b></mat-card-title>
                    <mat-icon>account_circle</mat-icon>
                </mat-card-header>
                <mat-card-content>
                    <div>
                        <span>מספר רישום בפנקס:</span>
                        {{w.RegistrationNumber}}
                    </div>
                    <div>
                        <span>תאריך רישום בפנקס:</span>
                        {{getRegistrationDate(w)}}
                    </div>
                    <button *ngIf="showPrint==true" mat-raised-button (click)="printClick(w)"><mat-icon>print</mat-icon> הדפסה</button>
                </mat-card-content>
            </mat-card>
        </div>-->
    </div>
    <div class="no-results-title" *ngIf="sw.ResultCode<1">
        {{sw.ResultMsg}}
    </div>
</form>
